module.exports = __webpack_public_path__ + "img/organizational-header.42627caf.svg";